const methodButtonNames = {
  IdCardButton: 'IdCardButton',
  IdCardButtonEE: 'IdCardButtonEE',
  IdCardButtonFi: 'IdCardButtonFi',
  IdCardButtonBe: 'IdCardButtonBe',
  SmartIdButton: 'SmartIdButton',
  MobileIdButton: 'MobileIdButton',
  MobileIdButtonEE: 'MobileIdButtonEE',
  EparakstsMobileButton: 'EparakstsMobileButton',
  EparakstsSmartCardButton: 'EparakstsSmartCardButton',
  FrejaEidButton: 'FrejaEidButton',
  ZealIdButton: 'ZealIdButton',
  MojeIdButton: 'MojeIdButton',
  FinnishTrustNetworkButton: 'FinnishTrustNetworkButton',
  FinnishTrustNetworkAdvancedFullButton: 'FinnishTrustNetworkAdvancedFullButton',
  AtHandyButton: 'AtHandyButton',
  IdCardButtonLv: 'IdCardButtonLv',
  IdCardButtonPt: 'IdCardButtonPt',
  OtpButton: 'OtpButton',
  GoogleButton: 'GoogleButton',
  EvrotrustButton: 'EvrotrustButton',
  BankIdButton: 'BankIdButton',
  DTrustSignMeButton: 'DTrustSignMeButton',
  MitIdButton: 'MitIdButton',
  ChaveMovelButton: 'ChaveMovelButton',
  NoBankIdButton: 'NoBankIdButton',
  ItsmeButton: 'ItsmeButton',
  CertEuropeUsbButton: 'CertEuropeUsbButton',
  CertSignUsbButton: 'CertSignUsbButton',
  IdinButton: 'IdinButton',
  VerifaiButton: 'VerifaiButton',
  SpidButton: 'SpidButton',
  AudkenniButton: 'AudkenniButton',
  YesComButton: 'YesComButton',
  EdoAppEidButton: 'EdoAppEidButton',
  SimplySignButton: 'SimplySignButton',
};

export default methodButtonNames;
